import {createSlice} from "@reduxjs/toolkit";

const signupSlice = createSlice({
  name: "signup",
  initialState: {
    loading: false,
    serverErrors: {},
    signupSuccess: false
  },
  reducers: {
    signupAction(state, action) {
      return {
        ...state,
        loading: true,
        signupSuccess: false
      }
    },
    setSignupServerSuccessAction(state, action) {
      return {
        ...state,
        loading: false,
        serverErrors: {},
        signupSuccess: true
      }
    },
    setSignupServerErrorsAction(state, action) {
      return {
        ...state,
        serverErrors: action.payload.errors,
        loading: false
      }
    },
    clearSignUpServerErrorsAction(state) {
      return {
        ...state,
        serverErrors: {},
        signupSuccess: false
      };
    }
  }
})

export const {signupAction, setSignupServerErrorsAction, setSignupServerSuccessAction, clearSignUpServerErrorsAction} = signupSlice.actions

export default signupSlice.reducer